<template>
  <div class="trade-detail">
    <div class="chart-title">Trade Detail</div>
    <div class="settings-button">
      <!-- <miniSettings :position="position" :minis="minis" /> -->
    </div>
    <div class="width-full float-left" style="padding: 20px;">
      <v-row v-if="data.active">
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right bold">Status</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left bold">Open</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">Date</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left">{{tradeDate}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">Time</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left">{{tradeTime}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">Symbol</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left">{{data.Symbol.user}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">P/L</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left">
          <v-btn
            x-small
            v-bind:color="data.OpenProfitLoss > 0 ? '#79C04D': (data.OpenProfitLoss < 0 ?'#E62163' : '#808F9C')"
          >${{data.OpenProfitLoss.toFixed(2)}}</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">RunUp</v-col>
        <v-col
          cols="7"
          class="titles-small pa-0 text-left trades-pl profit"
        >${{data.FlatToFlatMaximumOpenPositionProfit.toFixed(2)}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">DrawDown</v-col>
        <v-col
          cols="7"
          class="titles-small pa-0 text-left trades-pl loss"
        >${{data.FlatToFlatMaximumOpenPositionLoss.toFixed(2)}}</v-col>
      </v-row>
       <v-row v-if="data.active">
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right bold">Open Vol</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left bold">{{data.Quantity}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">Max Vol</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left">{{data.MaxOpenQuantity}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">Trade time</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left">{{timeIn}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="5" class="titles-small pa-0 pr-4 text-right">Trade type</v-col>
        <v-col cols="7" class="titles-small pa-0 text-white text-left">
          <span v-if="data.TradeType == 1" class="profit">Long</span>
          <span v-else class="loss">Short</span>
        </v-col>
      </v-row>
      <div class="chart-title-sm mt-4">Displayed by traders</div>
      <div class="width-full float-left text-center mt-4">
        <v-chip
          v-for="visitor in visitedBy"
          :key="visitor._id"
          pill
          class="ma-1 pointer"
          color="#404855"
          @click="routeUser(visitor.visitor.username)"
        >
          <v-avatar left>
           <Avatar
        v-if="visitor.visitor.avatar != null"
        class=""
        :src="`https://tradeinpool.com/upload/${visitor.visitor.avatar}.png`"
        :size="33"
      ></Avatar>
      <Avatar v-else class="" :username="visitor.visitor.username" :size="33"></Avatar>
          </v-avatar>
          
          {{visitor.visitor.username}}
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment-timezone");
import Avatar from "vue-avatar";
//import miniSettings from "./miniSettings";
export default {
  name: "MiniEquity",
  components: { //miniSettings,
  Avatar },
  props: ["data"],
  data() {
    return {
      tradeTime: null,
      tradeDate: moment
        .tz(this.data.openTimestamp, this.$store.getters.timezone)
        .format("L"),
      timeIn: null,
      tradeType: null,
      visitedBy: []
    };
  },
  watch: {
    data: function() {
      this.visitorsRegroup()
    }
  },

  mounted() {
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
    this.visitorsRegroup()
  },
  methods: {
    routeUser(user) {
      return this.$router.push({path: "/user/"+user});
    },
    visitorsRegroup() {
      var data = this.data._visitors;
      this.visitedBy = data.reduce((acc, obj) => {
        var exist = acc.find(
          ({ visitor }) =>  obj.visitor.username === visitor.username
        );
        if (!exist) {
          acc.push(obj);
        }
        return acc;
      }, []);
    },

    updateTimes() {
      this.tradeTime = moment
        .tz(this.data.openTimestamp, this.$store.getters.timezone)
        .format("HH:mm");

      if (this.data.active) {
        this.timeIn = moment().diff(moment(this.data.openTimestamp)); // 86400000
      } else {
        //alert(moment(this.data.openTimestamp))
        //alert(moment(this.data.CloseDateTime * 1000))
        //moment.duration(endTime.diff(startTime));
        this.timeIn = moment.duration(
          moment(this.data.CloseDateTime * 1000 + this.data.CloseMillis).diff(
            moment(this.data.openTimestamp)
          )
        ); // 86400000
      }
    }
  }
};
</script>

<style>
</style>